import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type LeaderBoardProps = IconComponentBaseProps;

export const Leaderboard = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: LeaderBoardProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        id="mask0_5052_105356"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5052_105356)">
        <path
          d="M2.66602 12.6668H5.55702V7.3335H2.66602V12.6668ZM6.55701 12.6668H9.44168V3.3335H6.55701V12.6668ZM10.4417 12.6668H13.3327V8.66683H10.4417V12.6668ZM1.66602 12.4617V7.53866C1.66602 7.20722 1.78402 6.9235 2.02002 6.6875C2.25602 6.4515 2.53974 6.3335 2.87118 6.3335H5.55702V3.53866C5.55702 3.20722 5.67502 2.9235 5.91102 2.6875C6.14702 2.4515 6.43074 2.3335 6.76218 2.3335H9.23652C9.56796 2.3335 9.85168 2.4515 10.0877 2.6875C10.3237 2.9235 10.4417 3.20722 10.4417 3.53866V7.66683H13.1275C13.459 7.66683 13.7427 7.78483 13.9787 8.02083C14.2147 8.25683 14.3327 8.54055 14.3327 8.872V12.4617C14.3327 12.7931 14.2147 13.0768 13.9787 13.3128C13.7427 13.5488 13.459 13.6668 13.1275 13.6668H2.87118C2.53974 13.6668 2.25602 13.5488 2.02002 13.3128C1.78402 13.0768 1.66602 12.7931 1.66602 12.4617Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
